export default __webpack_public_path__ + "static/media/Series-8000-8100-MPNH-Inline-Remote.545febc5.png";